<button
  class="copy-button"
  mat-icon-button
  [attr.aria-label]="'INBOX.COMMON.ACTION_LABELS.COPY' | translate"
  [matTooltip]="'INBOX.COMMON.ACTION_LABELS.COPY' | translate"
  (click)="copyMessage()"
>
  <mat-icon inline="true">{{ isCopied() ? 'done' : 'content_copy' }}</mat-icon>
</button>
